import { Dispatch } from "react";
import {
  LanguageEnum,
  LanguageProps,
  LanguageState,
  LanguageType,
} from "../language.props";
import { English, Spanish } from "../../../languages";

export const languagesActions = (dispatch: Dispatch<any>) => {
  const changeLanguage = (language: LanguageType, mutation: boolean = true) => {
    const getT = (): LanguageState => {
      switch (language) {
        // CADA TIPO DE LENGUAJE EN FORMATO DE DOS SIGLAS QUE VIENE EN "LanguageType" DEBE CORRESPONDER A SU ARCHIVO JSON DE LA CARPETA "language".
        // ASÍ, "es" CORRESPONDE AL "Spanish", POR LO CUAL RETORNAMOS TODOS LOS TEXTOS DEL JSON "Spanish"
        case "es":
          return Spanish;
        case "en":
          return English;

        default:
          return Spanish;
      }
    };

    const payload: LanguageProps = {
      t: getT(),
      currentLanguage: language,
    };

    if (mutation) {
      localStorage.setItem(LanguageEnum.SET, language);
    }

    return dispatch({ type: LanguageEnum.SET, payload });
  };

  return { changeLanguage };
};
